// Constants for search functionality
export const CaseType = {
  ALL: 'all',
  CIVIL: 'civil',
  CRIMINAL: 'criminal',
  ADMINISTRATIVE: 'administrative',
  TAX: 'tax',
  LABOR: 'labor',
} as const;

export const SortBy = {
  DATE_DESC: 'date-desc',
  DATE_ASC: 'date-asc',
  RELEVANCE: 'relevance',
  COURT: 'court',
} as const;

export const DateRange = {
  ALL: 'all',
  TODAY: 'today',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
  CUSTOM: 'custom',
} as const;